(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["beastnow-inner-beast"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('beastnow-inner-beast')) {
  customElements.define('beastnow-inner-beast', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.copy = JSON.parse(this.querySelector('[data-copy]').textContent);
      this.products = JSON.parse(this.querySelector('[data-products]').textContent);
      this.dialog = this.querySelector('dialog');
      this.questions = Array.from(this.querySelectorAll('[data-question]'));
      this.resultPanel = this.querySelector('[data-result]');
      this.savedPanel = this.querySelector('[data-saved]');
      this.answers = {};
      this.index = 0;
      this.returnFocus = null;
      this.preview = this.dataset.preview === 'true';
      this.emailAddress = '';
      this.querySelector('[data-open]').addEventListener('click', () => this.open());
      this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('close', () => {
        this.remember('dismissed', 7);
        if (this.returnFocus) this.returnFocus.focus();
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });
      this.querySelector('[data-next]').addEventListener('click', () => this.next());
      this.querySelector('[data-back]').addEventListener('click', () => this.back());
      this.querySelectorAll('input[type="radio"]').forEach(input => {
        input.addEventListener('change', () => {
          this.answers[input.name] = input.value;
          this.error('');
          this.querySelector('[data-next]').disabled = false;
        });
      });
      this.querySelectorAll('[data-restart]').forEach(button => button.addEventListener('click', () => this.restart()));
      this.querySelector('[data-email-form]').addEventListener('submit', event => this.submitEmail(event));
      const smsForm = this.querySelector('[data-sms-form]');
      if (smsForm) smsForm.addEventListener('submit', event => this.submitSms(event));
      this.showStep();
      if (this.dataset.autoOpen === 'true' && !this.preview && !window.Shopify?.designMode) {
        this.timer = window.setTimeout(() => {
          if (!this.shouldSuppress() && window.matchMedia('(min-width: 750px)').matches) this.open();
        }, 15000);
      }
    }
    disconnectedCallback() { window.clearTimeout(this.timer); }
    t(key) { return this.copy[key] || key; }
    shouldSuppress() {
      try {
        const state = JSON.parse(localStorage.getItem('beastnow_inner_beast_v1') || '{}');
        return Number(state.until) > Date.now();
      } catch { return false; }
    }
    remember(reason, days) {
      if (this.preview) return;
      try {
        const current = JSON.parse(localStorage.getItem('beastnow_inner_beast_v1') || '{}');
        const until = Date.now() + days * 86400000;
        if (Number(current.until) > until) return;
        localStorage.setItem('beastnow_inner_beast_v1', JSON.stringify({ reason, until }));
      } catch {}
    }
    open() {
      this.returnFocus = document.activeElement;
      if (!this.dialog.open) this.dialog.showModal();
      this.focusPanel();
      this.emit('inner_beast_started');
    }
    focusPanel() {
      const panel = this.resultPanel.hidden ? this.questions[this.index] : this.resultPanel;
      const title = this.savedPanel.hidden ? panel.querySelector('[data-focus]') : this.savedPanel.querySelector('[data-focus]');
      if (title) title.focus();
    }
    error(message) {
      const node = this.querySelector('[data-error]');
      node.textContent = message;
      node.hidden = !message;
    }
    showStep() {
      this.questions.forEach((panel, i) => { panel.hidden = i !== this.index; });
      this.resultPanel.hidden = true;
      this.savedPanel.hidden = true;
      this.querySelector('[data-navigation]').hidden = false;
      this.querySelector('[data-progress]').hidden = false;
      this.querySelector('[data-step-number]').textContent = String(this.index + 1);
      this.querySelector('[data-progress-bar]').value = this.index + 1;
      this.querySelector('[data-back]').hidden = this.index === 0;
      this.querySelector('[data-next]').textContent = this.t(this.index === 2 ? 'see_result' : 'next');
      this.querySelector('[data-next]').disabled = !this.answers[['beast', 'shopping', 'focus'][this.index]];
    }
    next() {
      if (!this.answers[['beast', 'shopping', 'focus'][this.index]]) { this.error(this.t('select_answer')); return; }
      if (this.index < 2) { this.index += 1; this.showStep(); this.focusPanel(); return; }
      this.showResult();
    }
    back() {
      if (this.index > 0) this.index -= 1;
      this.showStep();
      this.focusPanel();
    }
    restart() {
      this.error('');
      this.index = 0;
      this.showStep();
      this.focusPanel();
    }
    chooseProducts() {
      const audience = ['men', 'women'].includes(this.answers.shopping) ? this.answers.shopping : 'all';
      const score = product => {
        if (!product.available) return -1;
        if (audience !== 'all' && product.audience !== 'all' && product.audience !== audience) return -1;
        let value = 0;
        if (product.result === this.answers.beast) value += 6;
        if (product.focus === this.answers.focus) value += 12;
        if (audience !== 'all' && product.audience === audience) value += 2;
        if (product.audience === 'all') value += 1;
        return value;
      };
      const ranked = this.products.map((product, index) => ({ product, score: score(product), index }))
        .filter(item => item.score >= 0).sort((a, b) => b.score - a.score || a.index - b.index);
      const seen = new Set();
      const selected = [];
      for (const item of ranked) {
        if (seen.has(item.product.handle)) continue;
        if (audience === 'all' && selected.length < 2 && selected.some(p => p.audience === item.product.audience && p.audience !== 'all')) continue;
        selected.push(item.product);
        seen.add(item.product.handle);
        if (selected.length === 3) break;
      }
      if (selected.length < 3) for (const item of ranked) {
        if (seen.has(item.product.handle)) continue;
        selected.push(item.product); seen.add(item.product.handle);
        if (selected.length === 3) break;
      }
      return selected;
    }
    showResult() {
      this.result = this.t('result_' + this.answers.beast);
      this.picks = this.chooseProducts();
      this.questions.forEach(panel => { panel.hidden = true; });
      this.querySelector('[data-navigation]').hidden = true;
      this.querySelector('[data-progress]').hidden = true;
      this.resultPanel.hidden = false;
      this.savedPanel.hidden = true;
      this.querySelector('[data-result-title]').textContent = this.result;
      this.querySelector('[data-result-description]').textContent = this.t('desc_' + this.answers.beast);
      const grid = this.querySelector('[data-pick-grid]');
      grid.replaceChildren();
      for (const product of this.picks) {
        const card = document.createElement('a');
        card.className = 'ib-card';
        card.href = product.url;
        const img = document.createElement('img');
        img.src = product.image;
        img.alt = product.title;
        img.loading = 'lazy';
        img.width = 360; img.height = 420;
        const title = document.createElement('strong'); title.textContent = product.title;
        const price = document.createElement('span'); price.textContent = product.price;
        const action = document.createElement('span'); action.className = 'ib-card-action'; action.textContent = this.t('view_piece') + ' →';
        card.append(img, title, price, action);
        grid.append(card);
      }
      this.querySelector('[data-no-picks]').hidden = this.picks.length > 0;
      this.remember('completed', 90);
      this.focusPanel();
      this.emit('inner_beast_completed');
    }
    emit(name) {
      const detail = { event: name, result: this.result || null, version: '1.0' };
      this.dispatchEvent(new CustomEvent('beastnow:quiz', { bubbles: true, detail }));
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && Array.isArray(window.dataLayer)) window.dataLayer.push(detail);
    }
    birthdayProperties(form) {
      const month = form.elements.birthday_month?.value || '';
      const day = form.elements.birthday_day?.value || '';
      if (!month && !day) return {};
      if (!month || !day) throw new Error(this.t('birthday_error'));
      const date = new Date(Date.UTC(2000, Number(month) - 1, Number(day)));
      if (date.getUTCMonth() !== Number(month) - 1 || date.getUTCDate() !== Number(day)) throw new Error(this.t('birthday_error'));
      return {
        'BeastNOW Birthday': '2000-' + month.padStart(2, '0') + '-' + day.padStart(2, '0'),
        'BeastNOW Birthday Month': Number(month),
        'BeastNOW Birthday Day': Number(day),
        'BeastNOW Birthday Source': 'Inner Beast quiz',
        'BeastNOW Birthday Celebration': '2000-' + month.padStart(2, '0') + '-' + (month === '2' && day === '29' ? '28' : day.padStart(2, '0')),
        'BeastNOW Birthday Year Is Synthetic': true
      };
    }
    async request(payload) {
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 15000);
      try {
        const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(this.dataset.siteId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/vnd.api+json', Accept: 'application/vnd.api+json', revision: '2026-07-15' },
          body: JSON.stringify(payload), signal: controller.signal
        });
        if (!response.ok || response.headers.get('X-Klaviyo-Partial-Failure')) throw new Error('request_failed');
        return response;
      } finally { window.clearTimeout(timeout); }
    }
    payload(attributes, source, listId = this.dataset.listId) {
      return { data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes } } },
        relationships: { list: { data: { type: 'list', id: listId } } } } };
    }
    async submitEmail(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const button = form.querySelector('button[type="submit"]');
      if (button.disabled) return;
      const email = form.elements.email.value.trim();
      if (!form.elements.email.checkValidity() || !email) { this.error(this.t('email_error')); return; }
      if (!form.elements.email_consent.checked) { this.error(this.t('consent_error')); return; }
      let birthday;
      try { birthday = this.birthdayProperties(form); } catch (error) { this.error(error.message); return; }
      const properties = {
        'BeastNOW Inner Beast': this.result,
        'BeastNOW Main Interest': { gym: 'Gym Warrior', everyday: 'Quality Clothing Lover', competitive: 'Athlete' }[this.answers.beast],
        'BeastNOW Shopping Preference': this.answers.shopping,
        'BeastNOW Quiz Focus': this.answers.focus,
        'BeastNOW Lane': this.answers.focus === 'detroit' ? 'Detroit' : this.answers.beast === 'everyday' ? 'Everyday' : 'Training',
        'BeastNOW Quiz Version': '1.0',
        'BeastNOW Quiz Requested At': new Date().toISOString(),
        'BeastNOW Quiz Picks': this.picks.map(p => ({ title: p.title, handle: p.handle, url: p.url, image: p.image })),
        'BeastNOW Email Disclosure Version': '2026-10-01-v1',
        ...birthday
      };
      button.disabled = true; button.textContent = this.t('sending'); this.error('');
      try {
        if (!this.preview) await this.request(this.payload({ email, properties, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } }, 'BeastNOW Inner Beast quiz'));
        this.emailAddress = email;
        this.resultPanel.hidden = true; this.savedPanel.hidden = false;
        this.querySelector('[data-saved-message]').textContent = this.t(this.preview ? 'preview_saved' : 'saved');
        this.remember('subscribed', 180);
        this.focusPanel();
        this.emit('inner_beast_email_requested');
      } catch { this.error(this.t('submit_error')); }
      finally { button.disabled = false; button.textContent = this.t('send_result'); }
    }
    async submitSms(event) {
      event.preventDefault();
      const form = event.currentTarget;
      const button = form.querySelector('button[type="submit"]');
      if (button.disabled) return;
      let digits = form.elements.phone.value.replace(/\D/g, '');
      if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
      if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(digits)) { this.error(this.t('phone_error')); return; }
      if (!form.elements.sms_consent.checked) { this.error(this.t('sms_consent_error')); return; }
      const smsReady = this.dataset.smsReady === 'true' && this.dataset.smsTerms && this.dataset.smsTerms.startsWith('https://');
      if (!smsReady && !this.preview) { this.error(this.t('sms_error')); return; }
      if ((!this.dataset.smsListId || this.dataset.smsListId === this.dataset.listId) && !this.preview) { this.error(this.t('sms_error')); return; }
      button.disabled = true; button.textContent = this.t('sms_saving'); this.error('');
      try {
        if (!this.preview) await this.request(this.payload({
          email: this.emailAddress, phone_number: '+1' + digits,
          properties: { 'BeastNOW SMS Disclosure Version': '2026-10-01-v1', 'BeastNOW SMS Signup Source': 'Inner Beast quiz optional text step' },
          subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
        }, 'BeastNOW Inner Beast quiz optional text signup', this.dataset.smsListId));
        form.hidden = true;
        this.querySelector('[data-sms-confirmation]').textContent = this.t(this.preview ? 'preview_saved' : 'sms_saved');
        this.querySelector('[data-sms-confirmation]').hidden = false;
        this.emit('inner_beast_sms_requested');
      } catch { this.error(this.t('sms_error')); }
      finally { button.disabled = false; button.textContent = this.t('sms_join'); }
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
